// DiscoverShowMoreWrapper.jsx
'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { useParams, useLocation } from 'react-router';

import UniversalContainer from '../component/UniversalContainer.jsx';

import { getFeedCategory } from '../resource/feedUtils.js';

export const DiscoverShowMoreWrapper = ({ isShorts = false }) => {
  const { category: paramCategory } = useParams();
  const { search } = useLocation();
  const category = getFeedCategory({
    category: paramCategory,
    search,
  });
  const isFollowingStoryMore = 'pseudo_following_stories' === category;
  const filename = isFollowingStoryMore
    ? 'FollowingStoryMore'
    : isShorts
      ? 'ShortsMore'
      : 'FeedStoryMore';
  return <UniversalContainer filename={filename} category={category} />;
};

DiscoverShowMoreWrapper.propTypes = {
  isShorts: PropTypes.bool,
};

export default DiscoverShowMoreWrapper;
